<template>
  <section id="gtr-header_recently" class="gtr-header_recently">
    <pb-dropdown placement="bottom-start" @command="handleCommand" @visible-change="visibleChange">
      <div class="gtr-header_recently_div">
        <span ref="recentlySpan" class="gtr-header_recently_span">{{ $t('Gattaran_Homepage__Tchu' /*最近访问*/) }}</span>
        <pb-dropdown-menu slot="dropdown" ref="recentlyMenu" class="gtr-header_recently_menu" size="mini">
          <pb-dropdown-item v-for="item in history" :key="item.id" class="dropdown--item" :command="item">
            {{ item.moduleName }}
          </pb-dropdown-item>
        </pb-dropdown-menu>
      </div>
    </pb-dropdown>
  </section>
</template>
<script>
import { useRecentHistory } from '@/services/use-api';
import { isExternal, useRouter } from '@/utils';
import { computed, ref } from 'vue';
import { setRecentVisit } from '@/pages/overview/service';
import { getMatchPathByNodeKey } from '@/utils/route-menu';
import VueI18n from '@/i18n/locale';
import { useDriverListener } from '@/pages/layout/hooks';

/**
 * 处理引导的一些操作。
 * 引导聚焦的时候模拟鼠标移入事件，展开下拉框。
 * @returns {{recentlySpan: null}}
 */
function useDriver() {
  const recentlySpan = ref(null);
  const recentlyMenu = ref(null);
  const mouseenter = new Event('mouseenter');
  const mouseout = new Event('mouseout');
  useDriverListener('#gtr-header_recently', (evt) => {
    const preIndex = recentlyMenu.value.$el.style.zIndex;
    if (evt === 'in') {
      recentlySpan.value.dispatchEvent(mouseenter);
      setTimeout(() => {
        recentlyMenu.value.$el.style.zIndex = '100002';
      });
    }
    if (evt === 'out') {
      recentlySpan.value.dispatchEvent(mouseout);
      setTimeout(() => {
        recentlyMenu.value.$el.style.zIndex = preIndex;
      });
    }
  });
  return {
    recentlySpan,
    recentlyMenu,
  };
}
export default {
  setup(_) {
    const [history, setHistory, isLoading] = useRecentHistory();
    const router = useRouter();
    const historyList = computed(() => (history.value.length > 0 ? history.value : [{ moduleName: isLoading.value ? VueI18n.t('soda-b-web-i18n---加载中' /*'加载中'*/) : VueI18n.t('Gattaran_Homepage__nRqe' /*暂无访问记录*/) }]));
    return {
      // ...useDriver(),
      history: historyList,
      setHistory,
      visibleChange(evt) {
        if (evt) {
          setHistory();
        }
      },
      handleCommand(item) {
        const { nodeKey, activeMicroAppName = '' } = item;
        if (nodeKey) {
          const { matchPath } = getMatchPathByNodeKey(nodeKey);
          if (isExternal(matchPath)) {
            window.open(matchPath);
          } else {
            router.push(matchPath);
          }
          // 顶部导航最近访问增加最近访问
          setRecentVisit({
            nodeKey: nodeKey,
            activeMicroAppName,
          });
        }
      },
    };
  },
};
</script>
<style lang="scss" scoped>
@import '../style';
.gtr-header_recently {
  padding-left: 16px;
  padding-right: 10px;
  height: 48px;
  line-height: 48px;
  .gtr-header_recently_div {
    margin-top: 6px;
    height: 40px;
  }
  .gtr-header_recently_span {
    font-size: 14px;
    color: rgb(194, 196, 204);
    font-weight: 500;
    height: 100%;
    display: inline-block;
    &:hover {
      cursor: pointer;
      color: #fff;
    }
  }
}
.gtr-header_recently_menu {
  top: 42px !important;
  .dropdown--item {
    box-sizing: border-box;
    max-width: 320px;
    padding-left: 10px;
    padding-right: 10px;
    line-height: 32px;
    overflow: hidden; /*超出的部分隐藏起来。*/
    white-space: nowrap; /*不显示的地方用省略号...代替*/
    text-overflow: ellipsis; /* 支持 IE */
  }
}
</style>
